import { resolveActiveSessionProvider } from '@/hooks/integrations/resolveActiveSessionProvider';
import { isEnableBlockEditorV1 } from '@/hooks/useEnableBlockEditorV1';
import { ContentType } from '@heidi/schema/ml-scribe';

/**
 * The document content-type decision: the block-editor flag composed with
 * capture's active-session provider.
 *
 * App-owned by design (ARCFE-1004). `postCreateEmptyDocument` used to compute
 * this inside the api fn; when that fn moved to `@heidi/session/data` the read
 * could not go with it — it is a FLAG composed with provider resolution, and
 * per the E3 disposition the app resolves it and passes the value in. Lives
 * here rather than in each call site so there is one definition to
 * characterize (`scribeAPIV2.contentType.test.ts`).
 */
export const resolveDocumentContentType = (sessionId: string): ContentType =>
  isEnableBlockEditorV1(resolveActiveSessionProvider(sessionId))
    ? ContentType.HTML
    : ContentType.MARKDOWN;
